var map = {
	"./bondingcurve.json": 71562,
	"./lplocker.json": 9334,
	"./marspump.json": 93924,
	"./marspump_v2.json": 30892,
	"./powerpool.json": 75663,
	"./token.json": 74528,
	"./tokenpool.json": 90915,
	"./v3pool.json": 28475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7416;